import React , { useState , useEffect } from 'react';
import { Link , NavLink } from 'react-router-dom';
import menus from '../../pages/menu';
import './styles.scss';
import logo from '../../assets/images/logo/logo.png';
import logodark from '../../assets/images/logo/logo-dark.png';
import DarkMode from './DarkMode';

const FE_WEB_URL = 'https://app.tradiora.id';

const Header = () => {

    const [scroll, setScroll] = useState(false);
        useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 300);
        });
        return () => {
            setScroll(false);
        }
    }, []);

    const [menuActive, setMenuActive] = useState(null);

    const handleMenuActive = () => {
        setMenuActive(!menuActive);
      };

    
    const [activeIndex, setActiveIndex] = useState(null);
    const handleDropdown = index => {
        setActiveIndex(activeIndex === index ? null : index); 
    };

    return (
        <header id="header_main" className={`header ${scroll ? 'is-fixed' : ''}`}>
            <div className="container-fluid">
                <div className="row">
                <div className="col-12">
                    <div className="header__body d-flex justify-content-between">
                    <div className="header__left">
                        <div className="logo">
                        <NavLink to='/' className="light">
                            <img src={logo} alt="Tradiora" />
                        </NavLink>
                        <NavLink to='/' className="dark">
                            <img src={logodark} alt="Tradiora" />
                        </NavLink>
                        <span className="brand-text">TRADIORA</span>
                        </div>
                        <div className="left__main">
                            <nav id="main-nav" className={`main-nav ${menuActive ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) handleMenuActive(); }}>
                                <div className="mobile-menu-panel">
                                    <div className="menu-header">
                                        <div className="menu-logo">
                                            <img src={logo} alt="Tradiora" />
                                            <span className="brand-text">TRADIORA</span>
                                        </div>
                                        <button className="menu-close" onClick={handleMenuActive}>×</button>
                                    </div>
                                    <ul id="menu-primary-menu" className="menu">
                                    {
                                        menus.map((data,idx) => (
                                            <li key={idx} onClick={()=> handleDropdown(idx)} className={`menu-item ${data.namesub ? 'menu-item-has-children' : ''} ${activeIndex === idx ? 'active' : ''}`}>
                                                {data.links.startsWith('http') ? <a href={data.links}>{data.name}</a> : <Link to={data.links}>{data.name}</Link>}
                                                {
                                                    data.namesub &&
                                                    <ul className="sub-menu">
                                                        {
                                                            data.namesub.map((submenu) => (
                                                                <li key={submenu.id} className="menu-item">{submenu.links.startsWith('http') ? <a href={submenu.links}>{submenu.sub}</a> : <NavLink to={submenu.links}>{submenu.sub}</NavLink>}</li>
                                                            ))
                                                        }
                                                    </ul>
                                                }
                                            </li>
                                        ))
                                    }
                                    </ul>
                                    <div className="mobile-auth-buttons">
<a href={FE_WEB_URL} className="btn-login">Masuk</a>
<a href={FE_WEB_URL} className="btn-action"><span>Daftar Gratis</span></a>
                                    </div>
                                </div>
                            </nav>
                            
                 
                        </div>
                    </div>

                    <div className="header__right">
                        <DarkMode />

                        <a href={FE_WEB_URL} className="btn-login">Masuk</a>
                        <a href={FE_WEB_URL} className="btn-action"><span>Daftar Gratis</span></a>

                        <div className={`mobile-button ${menuActive ? 'active' : ''}`} onClick={handleMenuActive}><span></span></div>

                        
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </header>
       
    );
}

export default Header;
